import React from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
import { Link } from "react-router-dom";
import Languages from "../Mocks/Language";

export default function Projects() {
  // const trainingData = [
  //   {
  //     title: "CACES (Certificat d'Aptitude à la Conduite En Sécurité)",
  //     description:
  //       "Cette formation prépare les participants à obtenir le Certificat d'Aptitude à la Conduite En Sécurité pour la conduite de chariots élévateurs et autres engins de levage en toute sécurité.",
  //     image: require("../../assets/img/Examples Final/CACES.webp"),
  //     levels: "Débutant à expérimenté",
  //     duration: "35h",
  //     financing: "100% pris en charge OPCO – FAFIEC – AGEFICE",
  //     price: "À partir de 1200€",
  //     objectives: [
  //       "Maîtriser les règles de sécurité liées à l'utilisation des engins de levage",
  //       "Acquérir les compétences nécessaires pour conduire en sécurité divers types d'engins",
  //       "Savoir réaliser une inspection avant et après l’utilisation des engins",
  //       "Comprendre les normes légales et les obligations de sécurité sur les sites de travail",
  //       "Être capable d'intervenir efficacement en cas de situation d'urgence",
  //     ],
  //     modalities: [
  //       "Présentiel",
  //       "En entreprise",
  //       "Formation mixte (présentiel + e-learning)",
  //     ],
  //   },
  //   {
  //     title: "Kinésithérapie Respiratoire",
  //     description:
  //       "La kinésithérapie respiratoire est essentielle pour aider à améliorer les fonctions pulmonaires et traiter diverses pathologies respiratoires. Cette formation vous offre une maîtrise des techniques avancées de rééducation respiratoire.",
  //     image: require("../../assets/img/Examples Final/Kinesitherapie.webp"),
  //     levels: "Intermédiaire à avancé",
  //     duration: "40h",
  //     financing: "100% pris en charge OPCO – FNE – FIFPL",
  //     price: "À partir de 1500€",
  //     objectives: [
  //       "Comprendre l'anatomie et la physiologie du système respiratoire",
  //       "Appliquer les techniques de drainage postural et les techniques manuelles",
  //       "Utiliser les appareils de ventilation et d’assistance respiratoire",
  //       "Savoir évaluer l’efficacité des traitements de rééducation",
  //       "Adapter les protocoles de soins en fonction des pathologies respiratoires spécifiques",
  //     ],
  //     modalities: [
  //       "Présentiel",
  //       "Stage clinique",
  //       "Formation en ligne (théorique)",
  //     ],
  //   },
  //   {
  //     title: "Commerce avec la Chine",
  //     description:
  //       "Cette formation est idéale pour les professionnels souhaitant développer leurs compétences dans le commerce international avec la Chine, en abordant les aspects culturels, logistiques et commerciaux.",
  //     image: require("../../assets/img/Examples Final/Containers.webp"),
  //     levels: "Intermédiaire",
  //     duration: "30h",
  //     financing: "100% pris en charge OPCO – FNE – AGEFICE",
  //     price: "À partir de 1300€",
  //     objectives: [
  //       "Comprendre les particularités du marché chinois et ses opportunités",
  //       "Apprendre les techniques de négociation et de communication interculturelle avec les chinois",
  //       "Maîtriser les aspects logistiques du commerce avec la Chine",
  //       "Gérer les risques liés aux différences culturelles et juridiques",
  //       "Mettre en place une stratégie d’import-export efficace",
  //     ],
  //     modalities: ["Présentiel", "Webinaire", "E-learning"],
  //   },
  //   {
  //     title: "Coiffure et Esthétique",
  //     description:
  //       "Cette formation complète est dédiée aux futurs professionnels de la coiffure et de l'esthétique, permettant d'acquérir des compétences en coupe, coiffage, soins esthétiques et vente de produits.",
  //     image: require("../../assets/img/Examples Final/Esthétique.webp"),
  //     levels: "Débutant à avancé",
  //     duration: "120h",
  //     financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
  //     price: "À partir de 2000€",
  //     objectives: [
  //       "Apprendre les techniques de coupe et de coiffage sur tous types de cheveux",
  //       "Maîtriser les soins du visage, des ongles et du corps",
  //       "Comprendre les bases de la dermatologie esthétique",
  //       "Acquérir des compétences en gestion de salon et en conseil clientèle",
  //       "Développer une expertise dans les tendances et les produits cosmétiques",
  //     ],
  //     modalities: ["Présentiel", "Stage en entreprise", "Formation hybride"],
  //   },
  //   {
  //     title: "Stratégies de Marketing Digital",
  //     description:
  //       "Cette formation vous permet de maîtriser les fondamentaux et les stratégies avancées du marketing digital pour générer du trafic, améliorer l’engagement client et maximiser les conversions sur diverses plateformes numériques.",
  //     image: require("../../assets/img/Examples Final/Marketing Digital.webp"),
  //     levels: "Intermédiaire à avancé",
  //     duration: "40h",
  //     financing: "100% pris en charge OPCO – AGEFICE – FAFIEC",
  //     price: "À partir de 1800€",
  //     objectives: [
  //       "Développer une stratégie de contenu efficace pour le marketing digital",
  //       "Optimiser l’utilisation des réseaux sociaux pour la visibilité de la marque",
  //       "Maîtriser l’utilisation des outils SEO et SEM pour le référencement",
  //       "Analyser les performances marketing via les outils d’analyse web",
  //       "Créer et gérer des campagnes publicitaires payantes (Google Ads, Facebook Ads)",
  //     ],
  //     modalities: ["Présentiel", "Webinaire", "E-learning"],
  //   },
  //   {
  //     title: "Design Graphique Personnalisé",
  //     description:
  //       "Cette formation vous apprendra à concevoir des visuels percutants pour le web et l’imprimerie, en maîtrisant des logiciels comme Photoshop, Illustrator et InDesign. Idéale pour les créatifs souhaitant se spécialiser dans le design graphique personnalisé.",
  //     image: require("../../assets/img/Examples Final/Graphic-_Design.webp"),
  //     levels: "Débutant à intermédiaire",
  //     duration: "50h",
  //     financing: "100% pris en charge OPCO – FIFPL – FNE",
  //     price: "À partir de 1600€",
  //     objectives: [
  //       "Maîtriser les logiciels de création graphique (Adobe Photoshop, Illustrator, InDesign)",
  //       "Comprendre les bases du design visuel et de la typographie",
  //       "Créer des maquettes pour le web et l'impression",
  //       "Optimiser les visuels pour différents supports de communication",
  //       "Apprendre à travailler avec les clients pour créer des designs sur mesure",
  //     ],
  //     modalities: [
  //       "Présentiel",
  //       "Atelier pratique",
  //       "Formation en ligne avec tutorat",
  //     ],
  //   },
  // ];

  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Nos Formations de Qualité</h1>
            <p className="font13">
              Découvrez un univers riche en connaissances et en formations.
              Chaque information est une opportunité d'apprentissage où
              expertise et savoir-faire se rencontrent pour vous offrir des
              solutions adaptées.
            </p>
          </HeaderInfo>

          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <Link to="/formationV2" state={Languages.courses[0]}>
                <ProjectBox
                  img={require("../../assets/img/Examples Final/CACES.webp")}
                  title="CACES"
                  // text="Apprenez à obtenir votre certificat CACES pour travailler en toute sécurité avec des engins de chantiers."
                  // action={() => alert("Vous avez cliqué sur le CACES !")}
                />
              </Link>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <Link to={"formationV2"} state={Languages.courses[6]}>
                <ProjectBox
                  img={require("../../assets/img/Examples Final/IA.webp")}
                  title="Intelligence Artificielle (IA)"
                  // text="Formation complète sur la kinésithérapie en réhabilitation respiratoire et le traitement des pathologies respiratoires."
                />
              </Link>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <Link to={"/formationV2"} state={Languages.courses[4]}>
                <ProjectBox
                  img={require("../../assets/img/Examples Final/SST.webp")}
                  title="Sauveteur Secouriste du Travail (SST)"
                  // text="Formation sur la prévention et la prise en charge infirmière du risque suicidaire, douleur, et plus."
                />
              </Link>
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <Link to={"formationV2"} state={Languages.courses[2]}>
                <ProjectBox
                  img={require("../../assets/img/Examples Final/Esthétique.webp")}
                  title="Coiffure et Esthétique"
                />
              </Link>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <Link to={"formationV2"} state={Languages.courses[5]}>
                <ProjectBox
                  img={require("../../assets/img/Examples Final/Marketing Digital.webp")}
                  title="Stratégies de Marketing Digital"
                  // text="Mise en place de stratégies digitales pour augmenter votre présence en ligne et atteindre vos objectifs."
                  // action={() =>
                  //   alert(
                  //     "Vous avez cliqué sur les stratégies de marketing digital !"
                  //   )
                  // }
                />
              </Link>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <Link to={"formationV2"} state={Languages.courses[3]}>
                <ProjectBox
                  img={require("../../assets/img/Examples Final/Graphic-_Design.webp")}
                  title="Design Graphique Personnalisé"
                  // text="Création d'identités visuelles uniques et design graphique pour renforcer l'impact de votre marque."
                />
              </Link>
            </div>
          </div>
          <div className="row flexCenter">
            {/* <div style={{ margin: "50px 0", width: "200px" }}>
              <FullButton
                title="Voir Plus de Formations"
                action={() =>
                  alert("Vous avez cliqué pour voir plus de projets !")
                }
              />
            </div> */}
          </div>
        </div>
      </div>
      {/* <div className="lightBg">
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <AddLeftInner>
                <ImgWrapper className="flexCenter">
                  <img
                    className="radius8"
                    src={require("../../assets/img/Examples Final/IT - Copy.png")}
                    alt="add"
                  />
                </ImgWrapper>
              </AddLeftInner>
            </AddLeft>
            <AddRight>
              <h4 className="font15 semiBold">Un aperçu de notre univers</h4>
              <h2 className="font40 extraBold">
                L'innovation au cœur de notre mission
              </h2>
              <p className="font12">
                Notre entreprise est dédiée à l'innovation, avec une approche
                centrée sur les besoins spécifiques de nos clients. Nous
                combinons expertise technique et créativité pour développer des
                solutions qui repoussent les frontières du possible.
                <br />
                <br />
                Chaque projet est une nouvelle opportunité de transformer des
                idées en réalisations concrètes et impactantes.
              </p>
              <ButtonsRow
                className="flexNullCenter"
                style={{ margin: "30px 0" }}
              >
                <div style={{ width: "190px" }}>
                  <FullButton
                    title="Inscription"
                    action={() => alert("Inscription")}
                  />
                </div>
                <div style={{ width: "190px", marginLeft: "15px" }}>
                  <FullButton
                    title="Contactez-nous"
                    action={() => alert("Contactez-nous")}
                    border
                  />
                </div>
              </ButtonsRow>
            </AddRight>
          </Advertising>
        </div>
      </div> */}
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;
